/** @jsx jsx */
import { jsx } from '@emotion/core'

import MobileScreen from './MobileScreen'

export default ({ items, showChrome }) => {
	return (
		<div
			data-comp="workshowcase-mobile-1up"
			css={{
				flex: 1, // be large!
				maxWidth: '28rem', // but not too large.
			}}
		>
			{items.slice(0, 1).map(({ src, alt }, idx) => (
				<MobileScreen key={idx} src={src} alt={alt} showChrome={showChrome} />
			))}
		</div>
	)
}
